import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { createShellLikeId } from "@aviv-unified-frontend/internal";
import { BRAND_CONFIGURATION } from "../../../configs/brands";
import { useLayout } from "./useLayout";
export const Layout = ({ children }) => {
    const { headerFooterConfig, layoutMode } = useLayout();
    const { Header, Footer } = BRAND_CONFIGURATION.layout;
    return (_jsxs(Box, { backgroundColor: "color.background.default", minHeight: "100vh", display: "flex", flexDirection: "column", children: [_jsx(Box, { as: "div", id: createShellLikeId("layout__banner") }), layoutMode !== "hidden" && (_jsx(Header, { headerFooterConfig: headerFooterConfig, layoutMode: layoutMode })), children, layoutMode !== "hidden" && (_jsx(Footer, { headerFooterConfig: headerFooterConfig, layoutMode: layoutMode }))] }));
};
